export default __webpack_public_path__ + "static/media/pepper.b7d16dbc.jpg";